import noodleApiClient from '@/tsClient/servers/noodleApi';

/** Provenance metadata describing the origin of a canonical field value. */
type ApiProvenance = {
  actorId: string | null;
  createdAt: string;
  sourceCategory: string;
  sourceId: string | null;
};

/** A single version entry in a canonical field's history. */
type ApiFieldVersion = {
  id: string;
  provenance: ApiProvenance;
  value: unknown;
};

/** A resolved canonical field with its current value, conflict status, and history. */
type ApiResolvedField = {
  fieldPath: string;
  history: ApiFieldVersion[];
  isConflicted: boolean;
  provenance: ApiProvenance;
  value: unknown;
};

/** Response from the canonical fields API for a given case. */
type CanonicalFieldsResponse = {
  caseId: string;
  fields: Record<string, ApiResolvedField | null>;
  hasConflicts: boolean;
};

type Input = {
  caseId: string;
};

/** Fetches resolved canonical fields for a given case. */
const getCanonicalFields = async ({ caseId }: Input): Promise<CanonicalFieldsResponse> => {
  const response = await noodleApiClient.get(`/cases/${caseId}`);
  return response.data as CanonicalFieldsResponse;
};

export type { ApiFieldVersion, ApiProvenance, ApiResolvedField, CanonicalFieldsResponse };
export default getCanonicalFields;
